document
  .querySelectorAll(
    '.variant-picker [data-swatch-type="color"] input[type="radio"]'
  )
  .forEach((colorInput) => {
    if (colorInput.checked) selectColorVariant(colorInput.value);

    colorInput.addEventListener("change", () => {
      if (colorInput.checked) selectColorVariant(colorInput.value);
    });
  });

function selectColorVariant(color) {
  // define selected color variant value
  document.querySelectorAll("[data-color-value]").forEach((colorVal) => {
    colorVal.innerText = ` ${color}`;
  });

  // define selected color variant thumbnails
  document
    .querySelectorAll(
      ".product-gallery__thumbnail-scroller button.product-gallery__thumbnail"
    )
    .forEach((productThumbnail) => {
      if (
        productThumbnail.getAttribute("data-alt").trim().toLowerCase() ===
        color.trim().toLowerCase()
      ) {
        productThumbnail.style.display = "inline-block";
      } else {
        productThumbnail.style.display = "none";
      }
    });
}
